import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getMytickets = async (isUsedStatus, isMoreTickets) => {
  try {
    // 続きを見る(isMoreTickets:true)の時のみ、パラメータをafter={book_group_id}にする。
    if (isMoreTickets) {
      const bookGroups = store.getters["ticketing/bookGroups"];
      const bookGroupId = bookGroups[bookGroups.length - 1]["id"];
      // 未ログイン時のネイティブは不要なので、第4引数：isNotReCall:true
      const resp = await apiWrapper(
        "GET",
        `my-tickets?is_used=${isUsedStatus}&after=${bookGroupId}`,
        {},
        true
      );

      store.commit(
        "ticketing/setbookGroups",
        bookGroups.concat(filterRequestRefundTickets(resp.data))
      );
      return filterRequestRefundTickets(resp.data);
    } else {
      const resp = await apiWrapper(
        "GET",
        `my-tickets?is_used=${isUsedStatus}`,
        {},
        true
      );
      store.commit(
        "ticketing/setbookGroups",
        filterRequestRefundTickets(resp.data)
      );
      return filterRequestRefundTickets(resp.data);
    }
  } catch (err) {
    console.log('ERROR"" getMytickets()', err);
    throw err;
  }
};

const filterRequestRefundTickets = (tickets) => {
  return tickets.filter((ticket) => ticket.refund_request_status == null);
};
